import { ModelSelect } from 'vue-search-select';
import { minLength, required } from 'vuelidate/lib/validators';

export default {
  name: 'directTax',
  components: {
    ModelSelect
  },
  data() {
    return {
      unsubscribe: null,
      editMode: false,
      loader: false,
      showTaxModal: false,
      // showAlert: false,
      // isSuccess: false,
      // responseMsg: '',
      showAlertAdd: false,
      isSuccessAdd: false,
      responseMsgAdd: '',
      partyId: null,
      partyDirectTaxList: [],
      taxGroupList: [
        {
          value: null,
          text: null
        }
      ],
      taxForm: {
        selectedTaxGroup: {
          value: null,
          text: null
        },
        tan_no: null,
        party_direct_tax_id: 0,
        active: false
      },
      taxTableFields: [
        {
          key: 'tax_group'
        },
        {
          key: 'tax_group_id',
          class: 'd-none'
        },
        {
          key: 'tan_no',
          label: 'TAN No.'
        },
        {
          key: 'party_direct_tax_id',
          class: 'd-none'
        },
        {
          key: 'active'
        }
      ]
    };
  },
  validations: {
    taxForm: {
      selectedTaxGroup: {
        value: { required },
        text: { required }
      },
      tan_no: {
        required,
        minLength: minLength(10)
      }
    }
  },
  mounted() {
    this.eventBus.$off('directTaxDetils');
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save' && this.editMode) {
          this.addEditTax();
        }
        if (actionName === 'add') {
          this.showTaxModal = true;
          this.editMode = true;
          this.taxForm = {
            selectedTaxGroup: {
              value: null,
              text: null
            },
            tan_no: null,
            party_direct_tax_id: 0,
            active: true
          };
        }
        if (actionName === 'update') {
          this.editMode = true;
        }
      }
    });
    this.eventBus.$on('directTaxDetils', taxObj => {
      this.partyId = taxObj.partyId;
      this.loader = true;
      this.$store
        .dispatch('party/getPartyDetailsById', this.partyId)
        .then(response => {
          this.loader = false;
          this.partyDirectTaxList = response.data.data.direct_tax_details;
        });
    });
    this.getTaxGroup();
  },
  methods: {
    addEditTax() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const payload = {
          partyId: this.partyId,
          directTaxPayload: {
            party_direct_taxs: [
              {
                active: this.taxForm.active,
                party_direct_tax_id: this.taxForm.party_direct_tax_id,
                tan_no: this.taxForm.tan_no,
                tax_group_id: this.taxForm.selectedTaxGroup.value
              }
            ]
          }
        };
        this.loader = true;
        this.$store
          .dispatch('party/getDirectTax', payload)
          .then(response => {
            this.loader = false;
            this.showAlertAdd = true;
            if (response.status === 200) {
              // this.showTaxModal = false;
              // this.isSuccess = true;
              this.partyDirectTaxList = response.data.data.direct_tax_details;
              this.isSuccessAdd = true;
              this.showAlertAdd = true;
              this.responseMsgAdd = response.data.message;
            } else {
              // this.isSuccess = false;
              this.isSuccessAdd = false;
              this.showAlertAdd = true;
              this.responseMsgAdd = response.response.data.message;
            }
          })
          .catch(error => {
            // this.showTaxModal = false;
            // this.showAlert = true;
            // this.loader = false;
            this.loader = false;
            alert(error.message);
          });
      }
    },
    getTaxGroup() {
      this.$store
        .dispatch('party/getTaxGroup', 'DIRECTTAX')
        .then(response => {
          if (response.data.data) {
            const result = response.data.data;
            const salutationArr = result.map(type => {
              return {
                value: type.tax_group_id,
                text: type.tax_group
              };
            });
            this.taxGroupList = salutationArr;
          }
        })
        .catch(error => {
          alert(error.message);
        });
    },
    rowSelected: function(item) {
      this.taxForm = {
        selectedTaxGroup: {
          value: item.tax_group_id,
          text: item.tax_group
        },
        tan_no: item.tan_no,
        party_direct_tax_id: item.party_direct_tax_id,
        active: item.active
      };
      this.showTaxModal = true;
    },
    resetModal() {}
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
